import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import find from 'lodash/find';
import map from 'lodash/map';
import filter from 'lodash/filter';
import isNil from 'lodash/isNil';
import includes from 'lodash/includes';
import Label from 'components/ui/form/label';
import { FormFieldError } from 'components/ui/index';
import compact from 'lodash/compact';
import FormGroup from 'components/ui/form/form_group';
import classNames from 'classnames';
import './select.scss';
const styles = {
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
  },
  multiValueLabel: (base, state) => {
    return state.data.isFixed ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 } : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: 'none' } : base;
  },
};
const FormSelect = ({ label, input, options, formGroupProps, isMulti, disabled, meta, onSelect, menuPlacement, ...otherProps }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (isMulti) {
      const newValues = filter(options, (option) => {
        return includes(input.value, option.value);
      });
      setValue(newValues);
      onSelect && onSelect(newValues);
    } else {
      const value = find(options, (option) => {
        return option.value === input.value;
      });
      setValue(value);
    }
    if (isNil(input.value)) {
      setValue(null);
    }
  }, [input.value, options]);

  const handleChange = (option) => {
    if (isMulti) {
      const values = map(option, (item) => {
        return item.value;
      });
      input.onChange(values);
      onSelect && onSelect(values);
    } else {
      input.onChange(option.value);
      onSelect && onSelect(option);
    }
  };

  return (
    <FormGroup {...formGroupProps} data-cy={`${input.name}_select`}>
      {label && <Label>{label}</Label>}
      <Select
        {...otherProps}
        isMulti={isMulti}
        options={compact(options)}
        value={value}
        className={classNames('react-select', {
          'is-invalid': !isNil(meta.error) && meta.touched,
        })}
        menuPlacement={menuPlacement}
        menuPortalTarget={document.body}
        isDisabled={disabled}
        onChange={handleChange}
        styles={{ ...styles, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        isClearable={isMulti && value && value.some((v) => !v.isFixed)}
        key={value}
      />
      <FormFieldError meta={meta} className="d-block" />
    </FormGroup>
  );
};

FormSelect.defaultProps = {
  label: null,
  placeholder: null,
  isMulti: false,
  formGroupProps: {
    className: '',
  },
  meta: {
    error: null,
    touched: false,
  },
};

FormSelect.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  formGroupProps: PropTypes.shape({
    className: PropTypes.string,
  }),
};

export default FormSelect;
